/**
 * the logger module
 * @returns {Object} - the custom logger methods 'log', debug', 'info', 'warn', 'error'
 */
var logger = function () {

  var level = typeof window !== 'undefined'
    ? window.__LOG_LEVEL__ || 'info'
    : process.env.LOG_LEVEL || 'info'

  /**
   * Gets the log level and returns the console corresponding function
   * @param {String} lvl
   */
  function getLogFn (lvl) {
    lvl = lvl || 'log'
    var fn = console[lvl]
    return function () {
      var prefix = getLogPrefix(lvl)
      var logData = Array.from(arguments)
      logData.unshift(prefix)
      fn.apply(fn, logData)
    }
  }

  /**
   * Gets the string to insert as a prefix
   */
  function getLogPrefix (lvl) {
    var d = new Date()
    var date = d.toLocaleDateString()  + ' ' + d.toLocaleTimeString()
    return '[' + date + '] ' + lvl.toUpperCase() + ' : '
  }

  /**
   * A function that does nothing
   */
  function noop () {}

  return {
    level: level,
    log: getLogFn('log'),
    debug: ['debug'].indexOf(level) !== -1 ? getLogFn('debug') : noop,
    info: ['debug', 'info'].indexOf(level) !== -1 ? getLogFn('info') : noop,
    warn: ['debug', 'info', 'warn'].indexOf(level) !== -1 ? getLogFn('warn') : noop,
    error: getLogFn('error')
  }
}

// Module logic for bundlers
if (typeof module !== 'undefined' && module.exports) {
  exports = module.exports = logger()
}
